import { gql } from "@apollo/client";

export const FETCH_CORPORATE_VIEW = gql`
  query GetCorporateView {
    corporateView {
      name
      percentage
      supportedRevenue
      uuid
    }
  }
`;

export const FETCH_DIVISION_VIEW = gql`
  query divisionView {
    divisionView {
      divisions {
        name
        percentage
        uuid
      }
      location {
        locationName
        uuid
      }
      totalRevenue
    }
  }
`;

export const FETCH_PRODUCT_GROUP_VIEW = gql`
  query productGroupView($division: UUIDInput!) {
    groupView(division: $division) {
      groups {
        name
        percentage
        uuid
      }
      location {
        locationName
        uuid
      }
      totalRevenue
    }
  }
`;

export const FETCH_PRODUCT_VIEW = gql`
  query productView($productGroup: UUIDInput!) {
    productView(productGroup: $productGroup) {
      products {
        name
        percentage
        uuid
      }
      location {
        locationName
        uuid
      }
      totalRevenue
    }
  }
`;

export const FIND_DIVISION_BY_UUID = gql`
  query FindDivisionByUuid($uuid: ID!) {
    findDivisionByUuid(uuid: $uuid) {
      revenue
      uuid
      name
    }
  }
`;
